<template>
    <div>
      <div class="apl_code">
        <div class="flex_box">
          <span class="lable">手写签字校验关闭：</span>
          <el-input
            size="small"
            class="input"
            placeholder="请输入合同APL编号或批量签业务编号"
            v-model="aplCode"
          ></el-input>
          <el-button size="small" type="primary" @click="queryAplCodeFn"
          >关闭</el-button
          >
        </div>
        <p style="color: #ec1c1c; padding-left: 20px" v-show="errorAplCodeTip">
          <span style="color: #ffffff">手写签字校验关闭： </span>
          未查询到合同，请确认APL编号或批量签业务编号是否正确！
        </p>
        <p class="tip">
          提示：关闭后，当前合同个人签署方在进行手写签字时，无需校验手写签字与发起时填写的名称是否一致
        </p>
      </div>
      <el-dialog title="提示" :visible.sync="closeAplCodeVisible" width="30%">
        <p>确定关闭当前合同手写签字校验？</p>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="closeAplCodeVisible = false"
          >取 消</el-button
          >
          <el-button type="primary" size="mini" @click="closeAplCodeFn"
          >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {ApiMethods} from "../../assets/js/http-serve/http-methods";

    export default {
        name: "signCheck",
      data() {
          return {
            loading: null,
            aplCode: '', //apl编号
            closeAplCodeVisible: false,
            errorAplCodeTip: false, //未查询到编号提示
          }
      },
      methods: {
        //closeAplCodeFn关闭apl编号
        closeAplCodeFn () {
          ApiMethods.UserApplySignController.signWriteAiSwitch({
            applyNo: this.aplCode,
            flag: 1,
          }).then(res => {
            if (res.success) {
              this.aplCode = '';
              this.closeAplCodeVisible = false;
              this.$message({
                type: "success",
                message: "关闭成功"
              });
            } else {
              this.$message({
                type: "error",
                message: res.description,
              });
            }
          })
        },
        //查询apl编号
        queryAplCodeFn () {
          ApiMethods.UserApplySignController.commentsFindByApplyNo({
            applyNo: this.aplCode,
          }).then(res => {
            const data = res.data
            if (data) {
              // if (data.dealType === 17 || data.dealType === 20) return this.closeAplBatch()
              const REG = /^APL.*/
              if (!REG.test(this.aplCode)) return this.closeAplBatch()
              this.errorAplCodeTip = false;
              this.closeAplCodeVisible = true;
            } else {
              this.errorAplCodeTip = true;
            }
          })
        },
      }
    }
</script>

<style scoped lang="less">
  .apl_code {
    .flex_box {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .lable {
        font-size: 0.85vw;
        font-weight: bold;
        flex-shrink: 0;
      }
      .input {
        width: 300px;
        margin: 0 20px;
      }
    }
    .tip {
      // color: #555555;
      // margin-top: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// pages/tpl/signCheck.vue